<template>

<div class="list-view">

	<div class="sub-header">
		<div class="input-with-control">
			<input type="text" ref="search_term" v-model="filters.search_term" placeholder="Search..." @keyup.enter="getList(1)" v-focus>
			<div class="button action input-go" @click="getList(1)"><i class="fas fa-search"></i></div>
		</div>
		<div class="controls">
			<pagination v-if="showPagination" :paging="paging" @updatePage="goToPage"></pagination>
		</div>
	</div>

	<div class="filters" v-if="showFilters">

		<ul class="checkbox-group">
			<li>
				<span :class="['pointer', 'far', filters.internal_use_only ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('internal_use_only')"></span>
				<label>Hidden</label>
			</li>
			<li>
				<span :class="['pointer', 'far', filters.inactive ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('inactive')"></span>
				<label>Inactive</label>
			</li>
		</ul>

		<div class="divider"></div>

		<div class="button neutral" @click="clearFilters(1)">Clear Filters</div>
		<div class="button action" @click="addItem()">Add Reason Code</div>
		<div v-if="enableExport" :class="['button', gettingExport ? 'disabled' : 'action']" @click="doExport()">Export CSV</div>

		<div v-if="showDetail" class="button neutral" @click="backToList()">Back To List</div>

		<div class="message">{{ exportMessage }}</div>


	</div>

	<div v-if="showDetail" class="detail">
		<label>Description</label>
		<input type="text" v-model="listDetail.description"/>
		<div class="checkbox-group">
			<span :class="['pointer', 'far', listDetail.internal_use_only ? 'fa-check-square' : 'fa-square']" @click="listDetail.internal_use_only = !listDetail.internal_use_only"></span>
			<span class="label">Hidden</span>
		</div>
		<div class="checkbox-group">
			<span :class="['pointer', 'far', listDetail.inactive ? 'fa-check-square' : 'fa-square']" @click="listDetail.inactive = !listDetail.inactive"></span>
			<span class="label">Inactive</span>
		</div>

		<div class="controls">
			<button :class="['button', canSave ? 'action' : 'disabled']" @click="saveItem()">Save Reason Code</button>
			<div class="message">{{ saveMessage }}</div>
		</div>

	</div>

	<div v-else class="list">

	    <div v-if="list.length == 0" class="empty-list">
	        This list is empty
	    </div>

	    <table v-else class="data-list" cellpadding="0" cellspacing="0">
			<thead>
				<tr>
					<th class="list" align="left">Description</th>
					<th class="list" align="center">Hidden</th>
					<th class="list" align="center">Inactive</th>
				</tr>
			</thead>
			<tr v-for="(item, index) in list" class="clickable-list-item" @click="getItem(item)">
				<td class="list" align="left">{{ item.description }}</td>
				<td class="list" align="center"><i v-if="item.internal_use_only" class="fas fa-check"></i></td>
				<td class="list" align="center"><i v-if="item.inactive" class="fas fa-check"></i></td>
			</tr>
		</table>

	</div>

	<iframe id="download" src="" style="display: none;"></iframe>

	<help-popup :helpLink="{393:'Inventory Reason Codes'}" :tours="false"></help-popup>


</div>

</template>

<script>
import HelpPopup from '@/components/HelpPopup.vue'

export default {
	name: 'inventory-reason-codes',
    components: {
		'help-popup': HelpPopup
    },
	data() {
		return {
			client_id: '',
            loading: true,
			searchTip: '',
			page: 1,
			showPagination: false,
			showFilters: true,
			filters: {},
			filterMessage: '',
			filterLoading: false,
			definition: [],
			list: [],
			paging: {},
			showDetail: false,
			listDetail: {},
			enableExport: false,
			exportMessage: '',
			gettingExport: false,
			saveMessage: ''
		}
	},
	created() {
		this.clearFilters(true)
	},
	computed: {
		canSave() {
			return this.client_id == this.listDetail.client_id && this.listDetail.description
		}
	},
	methods: {
		clearFilters(getList) {
			this.filters = {
				page: 1,
				search_term: '',
				internal_use_only: 0,
				inactive: 0,
				do_export: 0
			}
			if (getList) {
				this.getList(1)
			}
		},
		getList(page) {
			this.loading = true
			this.apiCall({ destination: 'get_list_inventory_reason_codes', data: this.filters }).then(obj => {
				this.client_id = obj.client_id
				this.loading = false
				if (this.filters.do_export) {
					this.filters.do_export = 0
					var outputFile = obj.file_name
					// accommodate live server filecache latency
					setTimeout(() => {
						document.getElementById("download").src = "//" + document.location.hostname + "/download.php?file_name=" + obj.file_name + "&output_file_name=" + outputFile
						this.gettingExport = false
						this.exportMessage = ''
					}, 1500)
				} else {
					this.list = obj.list
					if (obj.paging) {
						this.paging = obj.paging
					}
				}
			}).catch(err => {
				console.log(err)
			})
		},
		toggleFilter(which) {
			this.filters[which] = !this.filters[which]
			this.getList(1)
		},
		getItem(item) {
			this.showDetail = true
			this.listDetail = item
		},
		addItem() {
			this.listDetail = {
				client_id: this.client_id,
				description: '',
				internal_use_only: 0,
				inactive: 0
			}
			this.showDetail = true
		},
		saveItem() {
			if (this.canSave) {
			this.loading = true
				this.apiCall({ destination: 'save_item_inventory_reason_code', data: this.listDetail }).then(obj => {
					this.loading = false
					if (obj.status == 'success') {
						this.backToList()
						this.getList(1)
					} else {
						this.saveMessage = obj.message
					}
				}).catch(err => {
					console.log(err)
				})
			}
		},
		backToList() {
			this.listDetail = {}
			this.showDetail = false
		},
		doExport() {
			if (this.gettingExport) {
				return false
			}
			this.gettingExport = true
			this.exportMessage = 'Generating CSV for ' + this.list.length + ' items...'
			this.filters.product_id = ''
			this.filters.do_export = true
			this.getList(1)
		}
	}
}
</script>

<style lang="scss" scoped>
</style>
